import React from 'react'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { useGlobalContext } from '../context';

const HeroSection = () => {
  const {name, photu, tdata} = useGlobalContext();
  return <Wrapper>
    <div className="container grid grid-two-column">

    <div className='section-hero-data'>
        <p className='hero-top-data'>{tdata}</p>
        <h1 className='hero-heading' >{name}</h1>
        <p className='hero-para'>{name} is a kind of College Specific Social Media where you could find your Seniors, classmates, Juniors and most important our Alumni</p>
        <Button classNa me="btn hireme-btn">
            <NavLink to='/contact'>GET STARTED</NavLink>
        </Button>
    </div>
    <div className='section-hero-image'>
      <picture>
        <img src={photu} alt='hero image' className='hero-img'/>
      </picture>
    </div>

    </div>
  </Wrapper>
}

const Wrapper = styled.section`

padding: 9rem auto ;
margin:5% 15% 15% 15%;

.section-hero-data{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding:auto;

}
.btn{
  max-width: 16rem;
}

.hero-top-data{
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.5rem;
  color: ${({theme})=>theme.colors.helper};
}

.hero-heading{
  text-transform:uppercase;
  font-size: 6.4rem;
}

.hero-para{
  margin-top: 1.5rem;
  margin-bottom: 3.4rem;
  max-width:60rem;
}
.section-hero-image{
  display: flex;
  justify-content: center;
  align-items: center;
}

picture{
  text-align: center;
}
.hero-img{
  max-width:80%;

}
@media (max-width: ${({theme})=> theme.media.mobile}){
.grid {
    gap: 7.2rem;
}
}
`;

export default HeroSection